<template>
    <div class="column-recommend-container">
        <ul>
            <li v-for="(item, i) in mpwxList" :key="i">
                <div class="logo-box">
                    <el-avatar :size="38" :src="item.logo ? item.logo : $store.state.defaultAvatar"></el-avatar>
                </div>
                <div class="info-box">
                    <div class="title-box">
                        <p>
                            <span>{{item.official_name}}</span>
                            <el-popover placement="bottom" trigger="hover">
                                <div style="display:flex;height:140px;">
                                    <img :src="item.ercode_img" alt="" 
                                        style="width:140px;height:140px;margin:auto;">
                                </div>
                                <div class="qrcode" slot="reference">
                                    <i class="icon iconfont icon-qr-scan-line"></i>
                                </div>
                            </el-popover>
                        </p>
                        <span class="follow" v-if="!item.isfollow" @click="followColumn(item.column_id, i)">+关注</span>
                        <div class="isfollow" v-else>已关注</div>
                    </div>
                    <p class="info">{{item.introduce}}</p>
                </div>
            </li>
        </ul>
        <!-- 关注弹窗 -->
        <el-dialog custom-class="follow-dialog-box" :visible.sync="followVisible" width="667px">
            <p class="follow-dialog-title">
                添加至
                <span>（需要选择一个时间戳才可以关注）</span>
            </p>
            <div class="follow-times-box">
                <div class="time-item" v-for="(item, i) in hourFolders" :key="i" :class="{active:timerIndex==item.id}" 
                    @click="handleTimerItem(item.id)">{{item.name}}</div>
            </div>
            <p class="new-title">新增</p>
            <div class="new-timer-box">
                <el-time-select v-model="timerValue" :picker-options="{ start: '00:00', step: '00:30', end: '23:30' }" 
                    placeholder="选择时间" :editable="false" @change="handleTimer()">
                </el-time-select>
                <el-button type="primary" size="mini" style="margin-left:10px;background:#215A92;" 
                    @click="addFolderTime()" v-show="newTimerFlag">确定</el-button>
            </div>
            <div class="follow-btn-box" v-show="followBtnsFlag">
                <el-button type="primary" size="small" style="background:#215A92;" @click="sureFollow()">确定</el-button>
                <el-button size="small" @click="cancelFollow()">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'ColumnRecommend',
    data() {
        return {
            columnList: [],
            followVisible: false,
            columnId: 0,
            hourFolders: [],
            // 时间选中项
            timerIndex: 0,
            // 新增时间值
            timerValue: '',
            // 新增时间确定按钮控制
            newTimerFlag: false,
            // 关注弹窗按钮控制
            followBtnsFlag: false,
            // 列表下标
            index: -1
        }
    },
    computed: {
        mpwxList() {
            return this.$store.state.articleModules.mpwxTrusteeshipList;
        }
    },
    created() {},
    methods: {
        /**
         * @function followColumn 关注栏目
         */
        followColumn(id, i) {
            this.index = i;
            this.columnId = id;
            this.followVisible = true;
            this.getHourFolders();
        },
        /**
         * @function getHourFolders 获取24小时文件夹列表
         */
        getHourFolders() {
            this.$axios.get(this.Urls.timerFolderList).then(res => {
                this.hourFolders = res.data.result.data;
            });
        },
        /**
         * @function handleTimerItem 选择时间选项
         */
        handleTimerItem(id) {
            this.timerIndex = this.timerIndex == id ? 0 : id;
            this.followBtnsFlag = this.timerIndex > 0;
        },
        /**
         * @function handleTimer 选择时间
         */
        handleTimer() {
            if(this.timerValue) {
                this.newTimerFlag = true;
            } else {
                this.newTimerFlag = false;
            }
        },
        /**
         * @function addFolderTime 添加时间文件夹
         */
        addFolderTime() {
            this.$axios.post(this.Urls.newTimerFolder, { name: this.timerValue }).then(res => {
                if(res.data.status == 200) {
                this.timerValue = '';
                this.newTimerFlag = false;
                this.getHourFolders();
                }
            });
        },
        /**
         * @function sureFollow 确定关注
         */
        sureFollow() {
            let sendData = {
                official_id: this.columnId,
                daydynamic_id: this.timerIndex
            };
            this.$axios.post(this.Urls.followMpwxColumn, sendData).then(res => {
                if(res.data.status == 200) {
                    this.mpwxList[this.index].isfollow = !this.mpwxList[this.index].isfollow;
                    this.cancelFollow();
                }
            });
        },
        /**
         * @function cancelFollow 取消关注，关闭弹窗
         */
        cancelFollow() {
            this.followVisible = this.newTimerFlag = this.followBtnsFlag = false;
            this.timerIndex = 0;
            this.timerValue = '';
        }
    }
}
</script>
<style lang="scss" scoped>
@import './ColumnRecommend.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/right-modules/column-recommend/ColumnRecommend.vue